import React from 'react'
import Icon from './Icon'

class ArrowForward extends React.Component {
  render () {
    return (
      <Icon {...this.props}>
        <svg viewBox='0 0 20 20' className='iconRight'>
          <g
            id='icons'
            stroke='none'
            strokeWidth='1'
            fill='none'
            fillRule='evenodd'
          >
            <g id='arrow_forward'>
              <polygon
                id='Icon'
                fill='#7E8DA2'
                className='icon__fill'
                points='12 4 10.59 5.41 16.17 11 4 11 4 13 16.17 13 10.59 18.59 12 20 20 12'
              />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default ArrowForward
